"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.function.name");
var _TaskAdd = _interopRequireDefault(require("./TaskAdd.vue"));
var _TaskRuleList = _interopRequireDefault(require("./TaskRuleList.vue"));
var _userTask = _interopRequireDefault(require("./userTask.vue"));
var _userTaskErr = _interopRequireDefault(require("./userTaskErr.vue"));
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserTaskConfig',
  components: {
    TaskAdd: _TaskAdd.default,
    TaskRuleList: _TaskRuleList.default,
    UserTask: _userTask.default,
    UserTaskErr: _userTaskErr.default
  },
  data: function data() {
    return {
      loading: false,
      taskAddKey: 0,
      // 每次更改它都会强制刷新 TaskAdd
      ruleOptions: [],
      activeTab: 'taskList',
      tabs: ['taskList', 'userTask', 'userTaskErr'],
      searchForm: {
        title: '',
        taskType: '',
        cycleDays: '',
        rewardType: '',
        status: '',
        page: 1,
        limit: 10,
        total: 0,
        sortField: '',
        sortOrder: '',
        // 'asc' / 'desc'
        ruleCode: ''
      },
      tableData: [],
      editingTaskId: null // 用于区分新增或编辑
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.searchForm.sortField = prop;
      this.searchForm.sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : '';
      this.fetchList();
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
    },
    removeTab: function removeTab(tabName) {
      var index = this.tabs.indexOf(tabName);
      if (index !== -1) this.tabs.splice(index, 1);
      if (this.activeTab === tabName) {
        this.activeTab = 'taskList';
      }
    },
    loadRuleOptions: function loadRuleOptions() {
      var _this = this;
      (0, _taskConfig.fetchAllTaskRules)().then(function (res) {
        _this.ruleOptions = res || [];
      });
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      (0, _taskConfig.getTaskList)(this.searchForm).then(function (res) {
        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.searchForm = {
        title: '',
        taskType: '',
        cycleDays: '',
        rewardType: '',
        status: '',
        page: 1,
        limit: 10,
        total: 0,
        sortField: '',
        sortOrder: '',
        // 'asc' / 'desc'
        ruleCode: ''
      };
      this.fetchList();
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    handleAdd: function handleAdd() {
      this.editingTaskId = null; // 清空 ID 表示新增
      if (!this.tabs.includes('taskAdd')) {
        this.tabs.push('taskAdd');
      }
      this.taskAddKey++; // 修改 key，强制组件重新挂载
      this.activeTab = 'taskAdd';
    },
    handleRule: function handleRule() {
      if (!this.tabs.includes('taskRuleList')) {
        this.tabs.push('taskRuleList');
      }
      this.taskAddKey++; // 修改 key，强制组件重新挂载
      this.activeTab = 'taskRuleList';
    },
    handleEdit: function handleEdit(row) {
      this.editingTaskId = row.id; // 设置编辑 ID
      if (!this.tabs.includes('taskAdd')) {
        this.tabs.push('taskAdd');
      }
      this.taskAddKey++; // 修改 key，强制组件重新挂载
      this.activeTab = 'taskAdd';
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      (0, _taskConfig.deleteTask)(row.id).then(function () {
        _this3.$message.success('删除成功');
        _this3.fetchList();
      });
    },
    handleToggleStatus: function handleToggleStatus(row) {
      var _this4 = this;
      var action = row.status === 1 ? '下架' : '上架';
      this.$confirm("\u786E\u5B9A".concat(action, "\u8BE5\u4EFB\u52A1\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var newStatus = row.status === 1 ? 0 : 1;
        (0, _taskConfig.toggleTaskStatus)(row.id, newStatus).then(function () {
          _this4.$message.success('状态更新成功');
          _this4.fetchList();
        });
      }).catch(function () {
        // 用户点击取消，无需任何操作
      });
    },
    onTaskSaved: function onTaskSaved() {
      this.removeTab('taskAdd');
      this.fetchList();
    },
    onTaskSaved2: function onTaskSaved2() {
      this.removeTab('taskRuleList');
      this.fetchList();
    }
  },
  mounted: function mounted() {
    this.loadRuleOptions();
    this.fetchList();
  }
};